// var baseURL = 'http://192.168.10.146:26300/'; // 服务器地址
// var baseURL = 'https://wechat.fqjrsn.cn'; // 服务器地址
var baseURL = ''; // 服务器地址
var ImgUrl = '';
var upload = '';
var uploadFile = '';
var pingImgUrl = '';
var pingExcel = '';
var otherUrl = '';
var scanCode = ''
var scanCode2 = ''
var ureport = ''
var RPCUrl = ''
var Websocket = 'ws://boyofj.3322.org:26430/websocket/'
let urlAddress = window.location.host
if (urlAddress == 'boyofj.3322.org:12900') {
  baseURL = 'http://boyofj.3322.org:12900';
  ImgUrl = 'http://boyofj.3322.org:12900/';
  upload = 'http://boyofj.3322.org:12900/api/sys/file/upload';
  uploadFile = 'http://boyofj.3322.org:12900/api/sys/file/upload';
  pingImgUrl = 'http://boyofj.3322.org:12900';
  pingExcel = 'http://boyofj.3322.org:12900';
  otherUrl = 'http://boyofj.3322.org:44444/getdemo';
  // otherUrl = 'http://127.0.0.1:44444/getcomm';
  scanCode = 'http://boyofj.3322.org:18888/Measurement/h5/dist/index.html#/home'   
  scanCode2 = 'http://192.168.10.100:18888/Measurement/h5/dist/index.html#/home'
  // ureport = 'http://192.168.10.178:26400'
  ureport = 'http://boyofj.3322.org:26508'
  RPCUrl = 'http://boyofj.3322.org:26418'
  // // scanCode = process.env.SCAN_CODE;
}else if (urlAddress.indexOf('localhost:808') != -1) {
  baseURL = 'http://localhost:26500';
  // baseURL = 'https://www.ylpiao.cn:26508';
  //  baseURL = 'http://boyofj.3322.org:12900';
  ImgUrl = 'http://boyofj.3322.org:12900/';
  upload = 'http://boyofj.3322.org:12900/api/sys/file/upload';
  uploadFile = 'http://boyofj.3322.org:12900/api/sys/file/upload';
  pingImgUrl = 'http://boyofj.3322.org:12900';
  pingExcel = 'http://boyofj.3322.org:12900';
  otherUrl = 'http://boyofj.3322.org:44444/getdemo';
  // otherUrl = 'http://127.0.0.1:44444/getcomm';
  scanCode = 'http://boyofj.3322.org:18888/Measurement/h5/dist/index.html#/home'   
  scanCode2 = 'http://192.168.10.100:18888/Measurement/h5/dist/index.html#/home'
  // ureport = 'http://192.168.10.178:26400'
  ureport = 'http://boyofj.3322.org:12900'
  RPCUrl = 'http://boyofj.3322.org:26418'
}else{
  baseURL = window.location.origin;
  ImgUrl = window.location.origin+'/';
  upload = window.location.origin+'/api/sys/file/upload';
  uploadFile = window.location.origin+'/api/sys/file/upload';
  pingImgUrl = window.location.origin;
  pingExcel = window.location.origin;
  otherUrl = 'http://127.0.0.1:44444/getcomm';
  scanCode = window.location.origin+'/h5/dist/index.html#/home'  
  scanCode2 = window.location.origin+'/h5/dist/index.html#/home'
  ureport = window.location.origin
  RPCUrl = window.location.origin
  Websocket = (window.location.protocol=='https:'?'wss://':'ws://')+window.location.host+'/websocket/'
}
export default {
  baseURL, // 后台地址
  ImgUrl, // 图片地址头部
  upload, // 图片上传接口
  uploadFile, // 文件上传接口
  pingImgUrl,// 图片回显
  pingExcel,// 导出
  otherUrl,//称重
  scanCode,//入场登记(外网)
  scanCode2,//入场登记(内网)
  ureport,//报表设计
  RPCUrl,//PRC监控
  Websocket,//Websocket
  // 请求头信息
  headers: {
    'Content-type': 'application/json'
  },
  // 设置超时时间
  timeout: 60000,
  withCredentials:true,
  // 返回数据类型
  responseType: 'json',
  mock: false // 本地静态数据
}



// WEBPACK FOOTER //
// ./src/api/config.js